/*
 *
 * LanguageProvider reducer
 *
 */

import produce from 'immer';
import API from '../../config/api';
import request from '../../utils/request';

import { CHANGE_USER_LOCATION, REMOVE_USER_LOCATION } from './constants';

export const initialState = {
	location: [],
};

/* eslint-disable default-case, no-param-reassign */
const languageProviderReducer = (state = initialState, action) => produce(state, (draft) => {
	switch (action.type) {
		// case CHANGE_USER_LOCATION:
		// 	draft.location.push(action.location);
		// 	const url = `${API()}/action/geofence?request=add-all`;

		// 	const options = {
		// 		url,
		// 		method: 'POST',
		// 		data: JSON.parse(JSON.stringify(draft.location)),
		// 	};
		// 	request(options).then((res) => {
		// 		console.log(JSON.stringify(res?.data), 'data'); // Use the data as needed
		// 		if (res.status === 200) {
		// 			console.log('Location added to geofence successfully');
		// 			draft.location = [];
		// 		}
		// 		// draft.location.splice(0, draft.location.length);
		// 		// state.location=[];
		// 		// if (data) {
		// 		// }
		// 	}).catch((err) => {
		// 		console.log('Error in adding location to geofence', err);
		// 	})
		// 	break;
		case CHANGE_USER_LOCATION:
			draft.location.push(action.location);
			break;

		case REMOVE_USER_LOCATION:
			draft.location = []; // clear when API confirms success
			break;

	}
});

export default languageProviderReducer;
